module.exports = __webpack_public_path__ + "public/img/j7rkjqk.e3db04bf.png";